module.exports = __webpack_public_path__ + "media/assets/images/blog/pexels-anton-46924-3e9f336e5c6442f7a7bd434e60dd0ed4.jpg";